import { u as useUniqueSelector, a as useNextFeaturesContext, N as NextThemeRootProvider, b as NextThemeProvider, _ as _toConsumableArray, B as Button, I as Icon } from './Link-e8624028.esm.js';
export { B as Button, C as ColorSchemeProvider, F as Fonts, I as Icon, c as IconButton, L as Link, M as Motion, f as NextProvider, T as ToastTarget, d as useColorScheme, e as useIsMotionReduced, i as useIsNextFeatureEnabled, h as useNextThemeRootClassName, u as useUniqueSelector } from './Link-e8624028.esm.js';
import { useTheme, Global, css } from '@emotion/react';
import { normalize } from 'polished';
import { useContext, Fragment, createContext, useState, useEffect, useRef, useCallback, useMemo, useReducer } from 'react';
import invariant from 'tiny-invariant';
import _omit from 'ramda/src/omit';
import _pick from 'ramda/src/pick';
import '@chakra-ui/system';
import 'ramda/src/has';
import { extendTheme, ButtonGroup as ButtonGroup$1, createStandaloneToast as createStandaloneToast$1, useToast as useToast$1, useBoolean, useEventListener, forwardRef, useCheckbox as useCheckbox$1, VisuallyHidden, chakra, useRadioGroupContext, useRadio as useRadio$1, RadioGroup, useMultiStyleConfig, Center, visuallyHiddenStyle, Stack, HStack, useListStyles, ListIcon as ListIcon$1 } from '@chakra-ui/react';
export { AspectRatio, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Center, CloseButton, Container, Divider, Editable, EditableInput, EditablePreview, EditableTextarea, Fade, Flex, Grid, HStack, Hide, Kbd as Hotkey, Input, InputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, LinkBox, LinkOverlay, List, ListItem, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuOptionGroup, OrderedList, PinInput, PinInputField, Portal, Progress, Radio, RadioGroup, ScaleFade, Show, SimpleGrid, Slide, SlideFade, Spacer, Stack, Tab, TabList, TabPanel, TabPanels, Table, Tabs, Tbody, Td, Textarea, Tfoot, Th, Thead, Tr, UnorderedList, VStack, VisuallyHidden, VisuallyHiddenInput, Wrap, calc, cssVar, forwardRef, shouldForwardProp, chakra as system, useBoolean, useClipboard, useColorMode, useConst, useControllableState, useCounter, useDimensions, useDisclosure, useEventListener, useId, useIds, useImage, useMediaQuery, useMergeRefs, useSafeLayoutEffect, useTimeout, useUnmountEffect, useUpdateEffect, visuallyHiddenStyle } from '@chakra-ui/react';
import warning from 'tiny-warning';
import { P as Provider, A as Alert, c as componentMessage, u as useContext$1, g as getToggleButtonGroupProps, a as useToggleButtonProps, C as CheckboxGroup, T as ToggleButtonGroupProvider, B as Body, b as TileCheckbox } from './Tag-2e115a37.esm.js';
export { A as Alert, f as Badge, h as Blockquote, P as BlueprintProvider, B as Body, l as Check, k as Checkbox, C as CheckboxGroup, H as Code, i as Collapse, D as Dialog, r as Drawer, F as Field, s as FilterMenu, I as Image, L as LoadingOverlay, t as LoadingState, z as Menu, E as MenuButton, G as MenuItemOption, M as Message, v as Modal, d as Panel, x as Popover, Y as SWIPE_THRESHOLD, m as Select, w as Sheet, S as Slider, n as StepperInput, q as TabHeading, j as Tag, o as TextInput, b as TileCheckbox, p as TileRadio, e as Toggle, y as Tooltip, W as layoutPropNames, X as onSwipe, Q as pickThemingProps, R as splitLayoutProps, U as splitSystemProps, V as systemPropNames, J as useBreakpoint, K as useBreakpointValue, N as useReducedMotionVariants, O as useTimeoutFlag } from './Tag-2e115a37.esm.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { includes } from '@hover/utilities';
import 'framer-motion';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { theme } from '@hover/chakra-theme';
export { variables as cssVariables, mapResponsive, reduceResponsive, theme } from '@hover/chakra-theme';
import { _ as _objectWithoutProperties, n as nextFeatures, a as _objectSpread2, g as attachNextThemeRoot, d as _slicedToArray, u as useTheme$1, w as withTestId, B as Box } from './ProgressiveLoader-d88010af.esm.js';
export { B as Box, H as Heading, L as Loader, P as ProgressiveLoader, L as Spinner, m as motion, n as nextFeatures, k as useNextTheme, u as useTheme } from './ProgressiveLoader-d88010af.esm.js';
export { useSize, useSizes } from '@chakra-ui/react-use-size';
import { callAll } from '@chakra-ui/shared-utils';
export { transition } from '@hover/chakra-theme/foundation';
export { createContext } from '@chakra-ui/react-utils';
export { RemoveScroll } from 'react-remove-scroll';
export { FocusLock } from '@chakra-ui/focus-lock';
import '@hover/tokens-typography';
import '@hover/tokens-typography/next';
import 'ramda/src/mergeDeepLeft';
import 'ramda/src/mergeLeft';
import '@hover/chakra-theme/next';
import '@hover/chakra-theme/components';
import '@hover/icons/constants';
import '@hover/icons';
import '@hover/tokens-size';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/**
 * Apply custom theme overrides to the default Blueprint theme
 *
 * @param overrides theme additions and/or customizations
 * @returns
 */
var applyThemeOverrides = function applyThemeOverrides(overrides) {
  return extendTheme(overrides, theme);
};

var _excluded$a = ["children", "features", "themeOverrides", "includeFonts"];
var revertedFeatures = ['space', 'sizes'];
var Context = /*#__PURE__*/createContext(false);
var DesignSystemProvider = function DesignSystemProvider(_ref) {
  var children = _ref.children,
    _ref$features = _ref.features,
    features = _ref$features === void 0 ? 'all' : _ref$features,
    _ref$themeOverrides = _ref.themeOverrides,
    themeOverrides = _ref$themeOverrides === void 0 ? {} : _ref$themeOverrides,
    _ref$includeFonts = _ref.includeFonts,
    includeFonts = _ref$includeFonts === void 0 ? true : _ref$includeFonts,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var existingTheme = useTheme();
  var className = useUniqueSelector('nested-design-system-provider-root');
  var selector = ".".concat(className);
  var next = (features === 'all' ? nextFeatures : features).filter(function (feature) {
    return !includes(revertedFeatures, feature);
  });
  var theme$1 = extendTheme({
    // TODO: merge tokens unique to Bauhaus into `existingTheme` here.
  }, themeOverrides, theme);
  var parentFeatures = useNextFeaturesContext();
  var isNested = useContext(Context);
  var isSubset = isNested && (parentFeatures === 'all' || next.every(function (feature) {
    return parentFeatures === null || parentFeatures === void 0 ? void 0 : parentFeatures.includes(feature);
  }));
  var isNestedSubset = isNested && isSubset;
  process.env.NODE_ENV !== "production" ? warning(isNestedSubset, 'BauhausProvider: this provider is nested in another `BauhausProvider`, so this is a no-op. You should remove this nested `BauhausProvider`.') : void 0;
  if (isNestedSubset) return children;

  // We're using the Emotion theme context to detect any nesting
  // and the default value for that context is an empty object
  if (Object.keys(existingTheme).length > 0) {
    var isDefined = !!children;
    var isObject = _typeof(children) === 'object';
    var isFragment = isDefined && isObject && 'type' in children && children.type === Fragment;

    // Do our best to throw an error if we can't attach CSS variables for the
    // nested theme. The direct descendent of `DesignSystemProvider` has to be a
    // DOM element that we can attach the CSS variable scope to.
    !(isDefined && isObject && !isFragment && 'props' in children && _typeof(children.props) === 'object') ? process.env.NODE_ENV !== "production" ? invariant(false, "BauhausProvider: unable to attach CSS variables to provided children: \n".concat(String(children))) : invariant(false) : void 0;
    return jsx(Context.Provider, {
      value: true,
      children: jsx(NextThemeRootProvider, {
        value: {
          className: className
        },
        children: jsx(NextThemeProvider, _objectSpread2(_objectSpread2({
          includeFonts: includeFonts !== false,
          next: next,
          outerTheme: theme$1,
          selector: selector
        }, props), {}, {
          children: attachNextThemeRoot(children, className)
        }))
      })
    });
  }
  return jsx(Context.Provider, {
    value: true,
    children: jsx(Provider, _objectSpread2(_objectSpread2({
      customTheme: theme$1,
      includeFonts: includeFonts,
      next: next
    }, props), {}, {
      children: children
    }))
  });
};

var ButtonGroup = ButtonGroup$1;

var _excluded$9 = ["isClosable", "description"];
var omitIcon = /*#__PURE__*/_omit(['icon']);

/**
 * Translate toast options into `Alert` props.
 *
 * @todo when we move over to `isClosable` for `Alert`, we can stop translating
 * that option
 *
 * @param options toast options
 * @returns `Alert` component props
 */
var translateOptions = function translateOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isClosable = _ref.isClosable,
    description = _ref.description,
    options = _objectWithoutProperties(_ref, _excluded$9);
  return _objectSpread2({
    showClose: isClosable,
    children: description
  }, _pick(['icon', 'status', 'title', 'variant', 'size'], options));
};
var wrap = function wrap(toast, defaultOptions) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  var isActive = toast.isActive,
    closeAll = toast.closeAll,
    close = toast.close,
    _update = toast.update,
    promise = toast.promise;
  var getRender = function getRender(options) {
    return function (_ref2) {
      var onClose = _ref2.onClose;
      return jsx(Alert, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        testId: "toast-alert",
        variant: "toast"
      }, translateOptions(defaultOptions)), translateOptions(options)), defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.props), options === null || options === void 0 ? void 0 : options.props), {}, {
        onCloseClick: onClose
      }));
    };
  };
  var wrapped = Object.assign(function (options) {
    return toast(_objectSpread2(_objectSpread2({}, omitIcon(options)), {}, {
      render: getRender(options)
    }));
  }, {
    isActive: isActive,
    closeAll: closeAll,
    close: close,
    promise: promise,
    update: function update(id, options) {
      return _update(id, _objectSpread2({
        render: getRender(options)
      }, omitIcon(options)));
    }
  });
  return wrapped;
};
var createStandaloneToast = function createStandaloneToast(standaloneOptions) {
  var _createChakraStandalo = createStandaloneToast$1(_objectSpread2({
      theme: theme
    }, standaloneOptions)),
    ToastContainer = _createChakraStandalo.ToastContainer,
    chakraToast = _createChakraStandalo.toast;
  return {
    ToastContainer: ToastContainer,
    toast: wrap(chakraToast, standaloneOptions === null || standaloneOptions === void 0 ? void 0 : standaloneOptions.defaultOptions)
  };
};
var useToast = function useToast(hookOptions) {
  var chakraToast = useToast$1(omitIcon(hookOptions));
  return wrap(chakraToast, hookOptions);
};
/**
 * Hook for displaying toasts with a custom render function
 */
var useCustomToast = useToast$1;

var useIsInitialRender = function useIsInitialRender() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isInitialRender = _useState2[0],
    setIsInitialRender = _useState2[1];
  useEffect(function () {
    return setIsInitialRender(false);
  }, []);
  return isInitialRender;
};

var useLatestCallback = function useLatestCallback(callback) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(callback);
  useEffect(function () {
    ref.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback].concat(_toConsumableArray(dependencies)));

  // Provides a stable function every render
  return useCallback(function () {
    return ref.current.apply(ref, arguments);
  }, []);
};

var defaultOptions = {
  zoom: 0.1,
  maxZoom: false,
  initialZoom: 1,
  initialX: 0.5,
  initialY: 0.5
};
var getScrollDirection = function getScrollDirection(event) {
  // Determine the scrolling direction based on the deltaY value
  var scrollDirection = Math.sign(event.deltaY);

  // Adjust the scroll direction based on macOS natural scrolling
  var isNaturalScrolling = /Macintosh|MacIntel/.test(navigator.platform) && event.deltaMode === WheelEvent.DOM_DELTA_PIXEL;
  return isNaturalScrolling ? scrollDirection * -1 : scrollDirection;
};
var transparentSpaceFiller;
var setSrcToBackground = function setSrcToBackground(image) {
  /* eslint-disable no-param-reassign */
  image.style.backgroundRepeat = 'no-repeat';
  image.style.backgroundImage = "url(\"".concat(image.src, "\")");
  transparentSpaceFiller = "data:image/svg+xml;base64,".concat(window.btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(image.naturalWidth, "\" height=\"").concat(image.naturalHeight, "\"></svg>")));
  image.src = transparentSpaceFiller;
  /* eslint-enable no-param-reassign */
};

var getIsZoomed = function getIsZoomed(_ref) {
  var actualHeight = _ref.actualHeight,
    actualWidth = _ref.actualWidth,
    zoomHeight = _ref.zoomHeight,
    zoomWidth = _ref.zoomWidth;
  return zoomWidth > actualWidth || zoomHeight > actualHeight;
};
var reducer = function reducer(_ref2) {
  var zoom = _ref2.zoom,
    maxZoom = _ref2.maxZoom;
  return function (state, action) {
    switch (action.type) {
      case 'wheel':
        {
          var eventX = action.x,
            eventY = action.y,
            direction = action.direction;
          var offsetX = state.offsetX,
            offsetY = state.offsetY,
            zoomWidth = state.zoomWidth,
            zoomHeight = state.zoomHeight,
            actualHeight = state.actualHeight,
            actualWidth = state.actualWidth;

          // Record the offset between the bg edge and cursor:
          var cursorBackgroundOffsetX = eventX - offsetX;
          var cursorBackgroundOffsetY = eventY - offsetY;

          // Use the previous offset to get the percent offset between the bg edge and cursor:
          var ratioX = cursorBackgroundOffsetX / zoomWidth;
          var ratioY = cursorBackgroundOffsetY / zoomHeight;
          var newWidth = zoomWidth;
          var newHeight = zoomHeight;

          // Update the background size
          if (direction < 0) {
            newWidth += zoomWidth * zoom;
            newHeight += zoomHeight * zoom;
          } else {
            newWidth -= zoomWidth * zoom;
            newHeight -= zoomHeight * zoom;
          }
          var constrainedWidth = Math.min(maxZoom * actualWidth, Math.max(newWidth, actualWidth));
          var constrainedHeight = Math.min(maxZoom * actualHeight, Math.max(newHeight, actualHeight));

          // Take the percent offset and apply it to the new size:
          var newX = eventX - constrainedWidth * ratioX;
          var newY = eventY - constrainedHeight * ratioY;
          var constrainedX = Math.max(actualWidth - constrainedWidth, Math.min(0, newX));
          var constrainedY = Math.max(actualHeight - constrainedHeight, Math.min(0, newY));
          return _objectSpread2(_objectSpread2({}, state), {}, {
            zoomWidth: constrainedWidth,
            zoomHeight: constrainedHeight,
            offsetX: constrainedX,
            offsetY: constrainedY
          });
        }
      case 'load':
        {
          return _objectSpread2(_objectSpread2({}, state), action.state);
        }
      case 'resize':
        {
          var width = action.width,
            height = action.height;
          return _objectSpread2(_objectSpread2({}, state), {}, {
            actualWidth: width,
            actualHeight: height,
            zoomWidth: width,
            zoomHeight: height,
            offsetX: 0,
            offsetY: 0
          });
        }
      case 'drag':
        {
          if (!getIsZoomed(state)) return state;
          var deltaX = action.deltaX,
            deltaY = action.deltaY;
          var _actualHeight = state.actualHeight,
            _actualWidth = state.actualWidth,
            _zoomWidth = state.zoomWidth,
            _zoomHeight = state.zoomHeight;
          var _newX = state.offsetX + deltaX;
          var _newY = state.offsetY + deltaY;
          var _offsetX = Math.max(_actualWidth - _zoomWidth, Math.min(0, _newX));
          var _offsetY = Math.max(_actualHeight - _zoomHeight, Math.min(0, _newY));
          return _objectSpread2(_objectSpread2({}, state), {}, {
            offsetX: _offsetX,
            offsetY: _offsetY
          });
        }
      default:
        return state;
    }
  };
};

/**
 * A hook for applying scroll/mouse wheel based zoom functionality to an image.
 * This is a React version of the `wheelzoom` library on npm, so all credit for
 * the technique used here goes to https://github.com/jackmoore.
 *
 * @see {@link https://github.com/jackmoore/wheelzoom/blob/master/wheelzoom.js}
 *
 * @example
 * ```tsx
 * const MyImage = () => {
 *   const zoom = useZoom({ zoom: 0.05, maxZoom: 5 });
 *   return <img src="..." {...zoom} />;
 * }
 * ```
 *
 * @param options zoom options
 */
var useZoom = function useZoom(options) {
  var settings = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultOptions), options);
  }, [options]);
  var maxZoom = settings.maxZoom || Infinity;
  var _useReducer = useReducer(reducer(_objectSpread2(_objectSpread2({}, settings), {}, {
      maxZoom: maxZoom
    })), {
      actualWidth: 0,
      actualHeight: 0,
      zoomWidth: 0,
      zoomHeight: 0,
      offsetX: settings.initialX,
      offsetY: settings.initialY
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var internalRef = useRef(null);
  var ref = useCallback(function (element) {
    // NOTE: this is to handle an edge case when the `ref` returned from
    // `useZoom` is passed to an image that is swapped in a carousel using `key`
    // to control how React unmounts the previous image. In that case the image
    // being unmounted sets the ref to `null` which breaks resize functionality
    // for the newly mounted incoming image.
    if (!element) return;
    internalRef.current = element;
  }, []);
  var onLoad = useCallback(function (event) {
    var image = event.currentTarget;
    var initial = Math.max(settings.initialZoom, 1);
    if (image.src === transparentSpaceFiller) return;

    // Prevent wheel events over the image from scrolling the page (we can't
    // do this in the `onWheel` handler because React handlers for wheel
    // events are passive by default)
    image.addEventListener('wheel', function (e) {
      return e.preventDefault();
    }, {
      passive: false
    });
    var computedStyle = window.getComputedStyle(image, null);
    var actualWidth = parseInt(computedStyle.width, 10);
    var actualHeight = parseInt(computedStyle.height, 10);
    var zoomWidth = actualWidth * initial;
    var zoomHeight = actualHeight * initial;
    dispatch({
      type: 'load',
      state: {
        actualWidth: actualWidth,
        actualHeight: actualHeight,
        zoomWidth: zoomWidth,
        zoomHeight: zoomHeight,
        offsetX: -(zoomWidth - actualWidth) * settings.initialX,
        offsetY: -(zoomHeight - actualHeight) * settings.initialY
      }
    });
    setSrcToBackground(image);
  }, [settings.initialX, settings.initialY, settings.initialZoom]);
  var onWheel = useCallback(function (event) {
    if (!internalRef.current) return;

    // NOTE: we're not using `clientX` and `clientY` from the mouse event in
    // case the event originates from a child element of the element we're
    // capturing scroll events from (in which case we'd get coordinates
    // relative to the wrong container)
    var rect = internalRef.current.getBoundingClientRect();
    var x = event.pageX - rect.left - window.pageXOffset;
    var y = event.pageY - rect.top - window.pageYOffset;
    if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;
    dispatch({
      type: 'wheel',
      x: x,
      y: y,
      direction: getScrollDirection(event)
    });
  }, []);
  var resize = useCallback(function () {
    if (!internalRef.current) return;
    var _internalRef$current$ = internalRef.current.getBoundingClientRect(),
      width = _internalRef$current$.width,
      height = _internalRef$current$.height;
    dispatch({
      type: 'resize',
      width: width,
      height: height
    });
  }, []);
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isMouseDown = _useBoolean2[0],
    _useBoolean2$ = _useBoolean2[1],
    mouseDown = _useBoolean2$.on,
    mouseUp = _useBoolean2$.off;
  var dragEventRef = useRef(null);
  var onMouseDown = useCallback(function (event) {
    event.preventDefault();
    dragEventRef.current = event.nativeEvent;
    mouseDown();
  }, [mouseDown]);
  useEventListener('mouseup', mouseUp);
  useEventListener('mousemove', function (event) {
    if (!dragEventRef.current || !isMouseDown) return;
    var clientX = event.clientX,
      clientY = event.clientY;
    var _dragEventRef$current = dragEventRef.current,
      previousX = _dragEventRef$current.clientX,
      previousY = _dragEventRef$current.clientY;
    dragEventRef.current = event;
    dispatch({
      type: 'drag',
      deltaX: clientX - previousX,
      deltaY: clientY - previousY
    });
  });
  var zoomWidth = state.zoomWidth,
    zoomHeight = state.zoomHeight,
    offsetX = state.offsetX,
    offsetY = state.offsetY;
  return {
    props: {
      ref: ref,
      onLoad: onLoad,
      onWheel: onWheel,
      onMouseDown: onMouseDown,
      style: {
        backgroundSize: "".concat(zoomWidth, "px ").concat(zoomHeight, "px"),
        backgroundPosition: "".concat(offsetX, "px ").concat(offsetY, "px")
      }
    },
    resize: resize,
    isZoomed: getIsZoomed(state)
  };
};

var Styles = function Styles(_ref) {
  var _ref$colors = _ref.colors,
    colors = _ref$colors === void 0 ? true : _ref$colors,
    _ref$fonts = _ref.fonts,
    fonts = _ref$fonts === void 0 ? true : _ref$fonts,
    _ref$normalize = _ref.normalize,
    normalize$1 = _ref$normalize === void 0 ? true : _ref$normalize;
  var theme = useTheme$1();
  var themeColors = theme.colors,
    themeFonts = theme.fonts;
  !(themeColors && themeFonts) ? process.env.NODE_ENV !== "production" ? invariant(false, componentMessage('Styles', 'unable to access theme, did you forget a `<BlueprintProvider />`?')) : invariant(false) : void 0;
  var getColors = function getColors() {
    return /*#__PURE__*/css("body{background-color:", themeColors.background, ";color:", themeColors.foreground, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getColors;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };
  var getFonts = function getFonts() {
    return /*#__PURE__*/css("body{font-family:", themeFonts.body, ";}h1,h2,h3,h4,h5,h6{font-family:", themeFonts.heading, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getFonts;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };
  return jsx(Global, {
    styles: /*#__PURE__*/css(colors ? getColors() : '', " ", fonts ? getFonts() : '', " ", normalize$1 ? normalize() : '', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var _excluded$8 = ["children"],
  _excluded2$2 = ["children", "isMinimal"];
var CheckButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var value = props.value;
  var group = useContext$1();
  var _useCheckbox = useCheckbox$1(getToggleButtonGroupProps({
      group: group,
      props: props,
      isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value.includes(value) : props.isChecked
    })),
    getCheckboxProps = _useCheckbox.getCheckboxProps,
    getInputProps = _useCheckbox.getInputProps,
    getLabelProps = _useCheckbox.getLabelProps,
    htmlProps = _useCheckbox.htmlProps,
    isChecked = _useCheckbox.state.isChecked;
  return jsxs(Button, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    as: "label",
    className: "hover--check-button"
  }, htmlProps), getLabelProps()), getCheckboxProps()), useToggleButtonProps({
    props: props,
    group: group,
    isChecked: isChecked
  })), {}, {
    // Since we're applying both `getLabelProps` and `getCheckboxProps` to
    // the root button as `label` element, we need to override the
    // `aria-hidden` value Chakra sets in `getCheckboxProps` (in a more
    // standard checkbox it gets applied to the visual control which is
    // adjacent to the `label` instead of wrapping everything)
    "aria-hidden": false,
    "data-checkbox": "",
    children: [jsx(VisuallyHidden, {
      children: jsx(chakra.input, _objectSpread2(_objectSpread2({}, getInputProps()), {}, {
        ref: ref
      }))
    }), children]
  }));
});
var CheckButtonGroup = function CheckButtonGroup(_ref2) {
  var children = _ref2.children,
    isMinimal = _ref2.isMinimal,
    props = _objectWithoutProperties(_ref2, _excluded2$2);
  return (
    // @ts-ignore
    jsx(CheckboxGroup, _objectSpread2(_objectSpread2({}, props), {}, {
      children: jsx(ToggleButtonGroupProvider, {
        value: {
          isMinimal: isMinimal
        },
        children: children
      })
    }))
  );
};

var _excluded$7 = ["children"],
  _excluded2$1 = ["children", "isMinimal"];
var RadioButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var value = props.value;
  var group = useRadioGroupContext();
  var _useRadio = useRadio$1(getToggleButtonGroupProps({
      group: group,
      props: props,
      isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value === value : props.isChecked
    })),
    getCheckboxProps = _useRadio.getCheckboxProps,
    getInputProps = _useRadio.getInputProps,
    getLabelProps = _useRadio.getLabelProps,
    htmlProps = _useRadio.htmlProps,
    isChecked = _useRadio.state.isChecked;
  return jsxs(Button, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    as: "label",
    className: "hover--radio-button"
  }, htmlProps), getLabelProps()), getCheckboxProps()), useToggleButtonProps({
    group: group,
    props: props,
    isChecked: isChecked
  })), {}, {
    // Since we're applying both `getLabelProps` and `getCheckboxProps` to
    // the root button as `label` element, we need to override the
    // `aria-hidden` value Chakra sets in `getCheckboxProps` (in a more
    // standard checkbox it gets applied to the visual control which is
    // adjacent to the `label` instead of wrapping everything)
    "aria-hidden": false,
    "data-radio": "",
    children: [jsx(VisuallyHidden, {
      children: jsx(chakra.input, _objectSpread2(_objectSpread2({}, getInputProps()), {}, {
        ref: ref
      }))
    }), children]
  }));
});
var RadioButtonGroup = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    isMinimal = _ref2.isMinimal,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  return jsx(RadioGroup, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: jsx(ToggleButtonGroupProvider, {
      value: {
        isMinimal: isMinimal
      },
      children: children
    })
  }));
});

var _excluded$6 = ["name", "isDisabled", "onChange"];

/**
 * Hook for implementing a custom checkbox button that also reads from `CheckboxGroup`
 * context. This composes Chakra's `useCheckbox` hook so it functions the same way
 * but automatically wires up its selection state from the `CheckboxGroup` context
 * if available.
 *
 * @see {@link https://chakra-ui.com/docs/hooks/use-checkbox}
 *
 * @param props checkbox props
 */
var useCheckbox = function useCheckbox(_ref) {
  _ref.name;
    var isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var group = useContext$1();
  var value = props.value;
  return useCheckbox$1(_objectSpread2(_objectSpread2({}, props), {}, {
    isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value.includes(value) : props.isChecked,
    isDisabled: (group === null || group === void 0 ? void 0 : group.isDisabled) || isDisabled,
    onChange: group !== null && group !== void 0 && group.onChange && props.value != null ? callAll(group.onChange, onChange) : onChange
  }));
};

var _excluded$5 = ["radioProps", "inputProps", "colorScheme", "size", "variant"];
/**
 * Radio control component intended to be used to render the radio selection
 * control within a custom radio component implemented with `useRadio`
 */
var RadioControl = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var radioProps = _ref.radioProps,
    inputProps = _ref.inputProps,
    colorScheme = _ref.colorScheme,
    size = _ref.size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var styles = useMultiStyleConfig('Radio', {
    colorScheme: colorScheme,
    size: size,
    variant: variant
  });
  return jsxs(Center, _objectSpread2(_objectSpread2({}, props), {}, {
    __css: styles.container,
    children: [jsx(chakra.input, _objectSpread2(_objectSpread2({
      className: "hover-radio-control__input"
    }, inputProps), {}, {
      ref: ref,
      style: visuallyHiddenStyle
    })), jsx(chakra.div, _objectSpread2(_objectSpread2({
      alignItems: "center",
      className: "hover-radio-control__control",
      display: "flex",
      justifyContent: "center"
    }, radioProps), {}, {
      __css: styles.control
    }))]
  }));
});

var _excluded$4 = ["name", "isDisabled", "onChange"];

/**
 * Hook for implementing a custom radio button that also reads from `RadioGroup`
 * context. This composes Chakra's `useRadio` hook so it functions the same way
 * but automatically wires up its selection state from the `RadioGroup` context
 * if available.
 *
 * @see {@link https://chakra-ui.com/docs/hooks/use-radio}
 *
 * @param props radio props
 */
var useRadio = function useRadio(_ref) {
  var _group$name;
  var name = _ref.name,
    isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var group = useRadioGroupContext();
  return useRadio$1(_objectSpread2(_objectSpread2({}, props), {}, {
    name: (_group$name = group === null || group === void 0 ? void 0 : group.name) !== null && _group$name !== void 0 ? _group$name : name,
    isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && props.value != null ? group.value === props.value : props.isChecked,
    isDisabled: (group === null || group === void 0 ? void 0 : group.isDisabled) || isDisabled,
    onChange: group !== null && group !== void 0 && group.onChange && props.value != null ? callAll(group.onChange, onChange) : onChange
  }));
};

var _excluded$3 = ["children", "spacing"];
var Form = function Form(_ref) {
  var children = _ref.children,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? '' : _ref$spacing,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return (
    // @ts-ignore
    jsx(Stack, _objectSpread2(_objectSpread2({
      spacing: spacing
    }, withTestId(props)), {}, {
      as: "form",
      children: children
    }))
  );
};

var _excluded$2 = ["children"],
  _excluded2 = ["box"];
var Label = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$2);
  if ('box' in props && props.box) {
    props.box;
      var boxProps = _objectWithoutProperties(props, _excluded2);
    return jsx(Box, _objectSpread2(_objectSpread2({}, boxProps), {}, {
      as: "label",
      ref: ref,
      children: children
    }));
  }
  return jsx(Body, _objectSpread2(_objectSpread2({}, props), {}, {
    element: "label",
    ref: ref,
    children: children
  }));
});

var _excluded$1 = ["content", "flexDirection", "heading", "onClick", "selected", "subHeading"];
var BlockOption = function BlockOption(_ref) {
  var content = _ref.content,
    _ref$flexDirection = _ref.flexDirection,
    flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
    heading = _ref.heading,
    onClick = _ref.onClick,
    selected = _ref.selected,
    subHeading = _ref.subHeading,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(selected || false),
    _useState2 = _slicedToArray(_useState, 2),
    isSelected = _useState2[0],
    setIsSelected = _useState2[1];
  var onClickBlockOption = useCallback(function () {
    setIsSelected(!isSelected);
    onClick === null || onClick === void 0 ? void 0 : onClick(!isSelected);
  }, [isSelected, onClick]);
  return jsx(TileCheckbox, _objectSpread2(_objectSpread2({
    description: content,
    isChecked: isSelected,
    onChange: onClickBlockOption,
    variant: flexDirection === 'row' ? 'horizontal' : 'vertical'
  }, props), {}, {
    children: jsxs(HStack, {
      justifyContent: "space-between",
      children: [jsx(Body, {
        "aria-level": 5,
        as: "span",
        fontWeight: "heading",
        role: "heading",
        children: heading
      }), flexDirection === 'column' && subHeading && jsx(Body, {
        "aria-level": 6,
        as: "span",
        color: "neutral.600",
        fontWeight: "heading",
        role: "heading",
        children: subHeading
      })]
    })
  }));
};

var _excluded = ["as", "icon", "orientation"];
// NOTE: we were originally requiring consumers to include `ListIcon` with the
// `as` prop set to `Icon` per Chakra's convention. A Chakra upgrade broke the
// icon styles that are applied to `ListIcon`, so this fixes that with the
// added bonus that we no longer require `as={Icon}` to be set manually.
var ListIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    icon = _ref.icon;
    _ref.orientation;
    var props = _objectWithoutProperties(_ref, _excluded);
  var styles = useListStyles();
  return jsx(ListIcon$1, _objectSpread2(_objectSpread2({
    as: as !== null && as !== void 0 ? as : Icon,
    icon: icon
  }, props), {}, {
    ref: ref,
    sx: styles.icon
  }));
});

var alpha = function alpha(value, color) {
  process.env.NODE_ENV !== "production" ? warning(false, "Directly importing the `alpha` helper is deprecated, no transparency will be applied to ".concat(color, ". Instead, use the `alpha` helper from the theme:\n\nimport { useTheme } from '@hover/blueprint';\n\nconst { colors } = useTheme();\ncolors.alpha(").concat(value, ", ").concat(color, ");\n")) : void 0;
  return color;
};

export { BlockOption, ButtonGroup, CheckButton, CheckButtonGroup, DesignSystemProvider, Form, Label, ListIcon, RadioButton, RadioButtonGroup, RadioControl, Styles, alpha, applyThemeOverrides, createStandaloneToast, useCheckbox, useCustomToast, useIsInitialRender, useLatestCallback, useRadio, useToast, useZoom };
